import apis from "../../core/apis.js";

class TravelRequestsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.travelRequests).get(options);
  }

  get(id) {
    return this.$resource(apis.travelRequests + id).get();
  }

  search(search = "") {
    return this.$resource(apis.travelRequests).get({ search });
  }

  update(id, item) {
    return this.$resource(apis.travelRequests + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
  resolve(id) {
    return this.$resource(apis.travelRequests + id + "/resolve").save();
  }
}

export default TravelRequestsResource;



// WEBPACK FOOTER //
// ./src/resources/travelRequests/travelRequests.resource.js